import React from 'react';

export function Avatar({ name, size = 28, tint, src = '' }) {
  const initials = name.split(' ').slice(0, 2).map((s) => s[0]).join('').toUpperCase();
  const hue = [...name].reduce((a, c) => a + c.charCodeAt(0), 0) % 360;
  const bg = tint || `oklch(0.88 0.04 ${hue})`;
  const fg = tint ? '#1A1612' : `oklch(0.35 0.06 ${hue})`;
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: bg, color: fg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.38, fontWeight: 700, letterSpacing: '-0.02em', flex: 'none',
      overflow: 'hidden',
    }}
    >
      {src
        ? <img src={src} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : initials}
    </div>
  );
}
